import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-evo-admin-school-group-students',
  templateUrl: './evo-admin-school-group-students.component.html',
  styleUrls: ['./evo-admin-school-group-students.component.css']
})
export class EvoAdminSchoolGroupStudentsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
